export default "__VITE_ASSET__CqbaeqHB__"